module.exports = __webpack_public_path__ + "4a16541ad8f5ebb86168113b042cbcb4.pdf";